import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { getStoryFeedFields } from "%/dynamic-component-editor/classes/platform-standard-entities";
import { camelToTitleCase } from "@bloglovin/vue-framework";

// Authored, not derived: camelToTitleCase turns `allItems` into "All Items",
// which says neither WHOSE items nor whether the set includes this story.
const FEED_LABELS = {
  previousItems: "My Previous Siblings",
  nextItems: "My Subsequent Siblings",
  allItems: "Me And My Siblings",
  otherItems: "My Siblings Without Me",
  folderItems: "My Folder Contents",
};

export default class StoryFolderFeedSelection extends BaseOption {
  static userInterfaceComponent = () => ({
    label: "Feed",
    // Rendered as the "Source" row inside GlobalFeedToolSet (one "Feed" group), not standalone.
    component: inspectorTools.NONE,
    props: {
      "data-test": "story-folder-feed-selection",
      options: getStoryFeedFields().map(fieldName => ({
        id: fieldName,
        // Falls back so a feed added to the entity def without a label here
        // still lists, rather than rendering a blank row.
        name: FEED_LABELS[fieldName] ?? camelToTitleCase(fieldName, true),
      })),
    },
  });

  static defaultValue = "";
}
